import { ICall } from "interfaces/ICall";
import IStatusUser from "interfaces/IStatusUser";
import { Store } from "pullstate";
import { StatusConstants } from "utils/constants";

interface IProps {
  status: string;
  lastCalls: ICall[];
  pauseStatus: string[];
  lastStatus: IStatusUser[];
  showingNotes: boolean;
  notes: string;
  pauseQueue: {
    isOnPauseQueue: boolean;
    pauseReason: string;
  };
  micStream: MediaStream | null;
  preTabbingStatus: string[];
}

export const UserStore = new Store<IProps>({
   status: StatusConstants.INACTIVE,
   lastCalls: [],
   pauseStatus: [],
   showingNotes: false,
   notes: localStorage.getItem("@notes") || "",
   pauseQueue: {
    isOnPauseQueue: false,
    pauseReason: "",
   },
   lastStatus: [],
   micStream: null,
   preTabbingStatus: [],
});
